var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"mb-1"},[_vm._v(" "+_vm._s(_vm.SStructType.name)+" ")]),_c('v-card-subtitle',[_vm._v(" "+_vm._s(_vm.SStructType.description)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }